(() => {
  const init = () => {
    const idea = new URLSearchParams(window.location.search).get('idea');
    if (!idea || !idea.trim()) return;
    document.querySelectorAll('[data-gr-idea-inquiry]').forEach((wrapper) => {
      const input = wrapper.querySelector('input');
      if (!input || !input.disabled) return;
      input.value = idea.trim().slice(0, 200);
      input.disabled = false;
      wrapper.hidden = false;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
